/**
 * @fileoverview Shared History schema used by both frontend and backend.
 * Immutable history table storing previous versions of notes.
 */

import { z } from 'zod';
import { commonValidators, createCrudSchemas, createEntityIdSchema, createdAtSchema, getSchemaFields } from './base.js';
import { ID_PATTERNS } from './types.js';

/**
 * History validation schema (immutable snapshots).
 * History rows are immutable and do not have updated_at.
 */
export const HistorySchema = z.object({
  id: createEntityIdSchema(ID_PATTERNS.HISTORY, 'ID must be in history nanoid7 format (hi + digit 2-9 + 4 alphanumeric)'),
  note_id: commonValidators.noteForeignKey('Note ID'),
  version_number: z.number()
    .int('Version number must be an integer')
    .positive('Version number must be greater than 0'),
  title: commonValidators.optionalString(255),
  content: z.string()
    .min(1, 'Content is required')
    .max(100000, 'Content must be 100000 characters or less'),
  metadata: commonValidators.jsonField('Metadata'),
  created_at: createdAtSchema,
});

const { CreateSchema } = createCrudSchemas(HistorySchema, { omitDeletedAt: false });

export const HistoryCreateSchema = CreateSchema;

export type History = z.infer<typeof HistorySchema>;
export type HistoryCreate = z.infer<typeof HistoryCreateSchema>;

export const HISTORY_FIELDS = getSchemaFields(HistorySchema);
